import { Injectable } from '@angular/core';
import { BehaviorSubject, debounceTime, ReplaySubject } from 'rxjs';
import { ProjectTotals } from './models/project-totals.model';

@Injectable({
  providedIn: 'root'
})
export class TotalsDataService {
  private totalHoursCostSource = new BehaviorSubject<number>(0);
  private totalHoursBillableSource = new BehaviorSubject<number>(0);
  private totalHoursBillableFinalSource = new BehaviorSubject<number>(0);
  private totalCostSource = new BehaviorSubject<number>(0);
  private totalBillableSource = new BehaviorSubject<number>(0);
  private totalBillableFinalSource = new BehaviorSubject<number>(0);

  currentTotalHoursCost = this.totalHoursCostSource.asObservable();
  currentTotalHoursBillable = this.totalHoursBillableSource.asObservable();
  currentTotalHoursBillableFinal = this.totalHoursBillableFinalSource.asObservable();
  currentTotalCost = this.totalCostSource.asObservable();
  currentTotalBillable = this.totalBillableSource.asObservable();
  currentTotalBillableFinal = this.totalBillableFinalSource.asObservable();

  private savingStatusSource = new BehaviorSubject<string>('Saved');
  currentSavingStatus = this.savingStatusSource.asObservable();

  private projectTotalsSource$ = new BehaviorSubject<ProjectTotals>({});
  public currentProjectTotals$ = this.projectTotalsSource$.asObservable();

  private changes$ = new ReplaySubject<void>(1);

  public changeProjectTotals(projectTotals: ProjectTotals) {
    this.projectTotalsSource$.next(projectTotals);
  }
  changeSavingStatus(savingStatus: string) {
    this.savingStatusSource.next(savingStatus);
  }

  changeTotalHoursCost(totalHoursCost: number) {
    this.totalHoursCostSource.next(totalHoursCost);
  }
  changeTotalHoursBillable(totalHoursBillable: number) {
    this.totalHoursBillableSource.next(totalHoursBillable);
  }
  changeTotalHoursBillableFinal(totalHoursBillableFinal: number) {
    this.totalHoursBillableFinalSource.next(totalHoursBillableFinal);
  }
  changeTotalCost(totalExpenseCost: number) {
    this.totalCostSource.next(totalExpenseCost);
  }
  changeTotalBillable(totalExpenseBillable: number) {
    this.totalBillableSource.next(totalExpenseBillable);
  }
  changeTotalBillableFinal(totalBillableFinal: number) {
    this.totalBillableFinalSource.next(totalBillableFinal);
  }

  public change() {
    this.changes$.next();
  }

  public observeChanges() {
    return this.changes$.asObservable().pipe(debounceTime(200));
  }
}
